import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../components/ThemeSwitcher/ThemeSwitcher";
import "./AnimalSighting.css";
import AnimalApprovedRecords from "./AnimalApprovedRecords";
import AnimalPendingRecords from "./AnimalPendingRecords";
import { FaPlus } from "react-icons/fa6";
import { createPortal } from "react-dom";
import { applyTheme, updateAllCharts, updateImages } from "../../utils/theme";
import { useUserGroups } from "../../../src/components/common/Auth/UserGroupsContext";
import { useEDPContext } from "../../components/EDPContext";
// import { SymbolUtils } from "../../modules/enviroportal/components/eDraw/SymbolUtils";
let elementInstances = {}
const AnimalSighting = ({ onClose, fullView, ...props }) => {
  const { mapview } = props;
  const { t } = useTranslation();
  const { groupNames, groupFunctions, groupServices } = useUserGroups();
  const groupMap = {
    [t("Invertebrates")]: window.userGroups.invertebrates,
    [t("Plants")]: window.userGroups.plants,
    [t("Mammals")]: window.userGroups.mammals,
    [t("Reptiles")]: window.userGroups.reptiles,
  };

  const pendingRecordList = [t("Invertebrates"), t("Plants"), t("Mammals"), t("Reptiles")];
  const filteredPendingRecordList = pendingRecordList.filter(
    (item) => groupNames.includes(groupMap[item])
  );
  let { theme } = useTheme();
  theme = localStorage.getItem("theme") || theme;
  const { globalDataContextValue } = useEDPContext();
  const { globalData, setGlobalData } = globalDataContextValue;
  const AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
  const [activeTab, setActiveTab] = useState(AnimalSightingTab.activeTab ? AnimalSightingTab.activeTab : "pendindRecords");
  const [showForm, setShowForm] = useState(false);
  const [sptledit, setSptlEdit] = useState(false);
  const isSmallScreenAni = window.matchMedia("(max-width: 767px)").matches;
  const divLabelIndicator = useRef(null);
  const isUnmounted = useRef(false);
  const updateTheme = (event) => {
    const newTheme = event.detail;
    theme = newTheme;
    //updateAllCharts(chartInstances, theme, t);
    applyTheme(elementInstances, theme, "AnimalSighting")
  };

  useEffect(() => {
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, [])
  useEffect(() => {
    setGlobalData(prev =>
      prev.map(m =>
        m.moduleName === "Animal Sighting"
          ? { ...m, activeTab: activeTab }
          : m
      )
    );
  }, [activeTab]);
  useEffect(() => {
    if (!mapview) return;


    if (divLabelIndicator.current) {
      mapview.ui.remove(divLabelIndicator.current);
      mapview.ui.remove(document.getElementById("divLabelIndicator"))
      mapview.ui.add(divLabelIndicator.current, "bottom-left");
      divLabelIndicator.current.style.display = "block";
    }

    return () => {
      // ["PlantsGraphicLayerId", "MammalsGraphicLayerId", "ReptilesGraphicLayerId", "InsectsGraphicLayerId"]
      //   .forEach(id => mapview?.map?.findLayerById(id)?.removeAll?.());
      mapview?.graphics?.removeAll();
      isUnmounted.current = true; // Mark as unmounted
    }

  }, [mapview]);

  const handleSpatialSearch = () => {
    setSptlEdit(true);
  };

  const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= breakpoint);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  };

  const isMobile = useIsMobile();

  const addBtn = (
    <button className="btn animal-add-btn" onClick={() => setShowForm(!showForm)}>
      <FaPlus size={13} style={{ marginTop: '-2px', marginRight: '5px' }} /> {t("addRecord")}
    </button>
  )
  const widgetMobEl = document.getElementById('widgetMob');

  return (
    <div id="" className="animal-sighting-data">
      {!showForm && (
        <div className="display-flex-animal">
          <div
            className="top-nav-tabs EnviroTabs mb-0"
            ref={(el) => { if (el) elementInstances["div1"] = el; }}
            style={theme === "dark" ? { borderColor: "#fff" } : {}}
          >
            <div
              className={`tab ${activeTab === "pendindRecords" ? "active" : ""}`}
              onClick={() => setActiveTab("pendindRecords")}
            >
              {t("Pending Records")}
            </div>
            <div
              className={`tab ${activeTab === "approvedRecords" ? "active" : ""}`}
              onClick={() => setActiveTab("approvedRecords")}
            >
              {t("Approved Records")}
            </div>

          </div>
          <div className="d-flex">
            {activeTab === "pendindRecords" && (
              <>
                <button className="button-with-image fullhide-AS" onClick={handleSpatialSearch} title={t("Spatial Search")} >
                  <img
                    src={`${process.env.PUBLIC_URL}/images/AnimalSighting/SpatialSearch.png`}
                    alt="Spatial Search"
                  />
                </button>
                {
                  (
                    isMobile && widgetMobEl
                      ? createPortal(addBtn, widgetMobEl)
                      : addBtn
                  )
                }
                {isSmallScreenAni && (
                  <button className="btn animal-add-btn dobs" onClick={() => setShowForm(!showForm)}>
                    <FaPlus size={13} style={{ marginTop: '-2px', marginRight: '5px' }} /> {t("addRecord")}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      )}
      <div className={`mt-3 flex-1 h-100 ${showForm ? "hidesection-mt-0" : ""}`}>
        {activeTab === "approvedRecords" && <AnimalApprovedRecords mapview={mapview} fullView={fullView} />}
        {activeTab === "pendindRecords" && <AnimalPendingRecords mapview={mapview} isUnmounted={isUnmounted} showForm={showForm} setShowForm={setShowForm} sptledit={sptledit} setSptlEdit={setSptlEdit} onClose={onClose} fullView={fullView} />}
      </div>
      {createPortal(
        <div
          id="divLabelIndicator"
          className="divLabelIndicator"
        >
          <div>
            <div className="indicatorAnimalBtn" style={{ display: "flex", gap: "0.25rem" }}>
              {filteredPendingRecordList.map((tab) => (
                <button
                  // key={tab}
                  key={t("DeleteAlertMessage", { attrName: tab })}
                  value={tab} style={{ display: "flex", alignItems: "center", border: "none", backgroundColor: "transparent" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "0.65rem",
                      height: "0.65rem",
                      borderRadius: "50%",
                      marginRight: "3px",
                      marginLeft: "3px",
                      //backgroundColor: tab === "Plants" ? "limegreen" : tab === "Mammals" ? "lightslategray" : tab === "Invertebrates" ? "blue" : tab === "Reptiles" ? "mediumpurple" : "",
                      backgroundColor: tab === t("Plants") ? "limegreen" : tab === t("Mammals") ? "darkgray" : tab === t("Invertebrates") ? "darkslateblue" : tab === t("Reptiles") ? "darkmagenta" : "",
                    }}
                  ></span>{tab}
                </button>
              ))}
            </div>

          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default AnimalSighting;
